<template>
  <v-card outlined class="pa-2 mx-4 mb-6 elevation-0">
    <v-row>
      <v-col cols="3">
        <v-col cols="12">
          <h2>Chương trình</h2>
        </v-col>
      </v-col>
      <v-col cols="9">
        <v-row class="ma-4 ml-0 justify-end">
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #fff9d0"
            >
              <div style="font-size: 24px"><strong>9</strong></div>
              <div class="text-caption"><strong>Bộ môn</strong></div>
            </v-card>
          </v-col>
          <v-col class="mr-4 pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #caf4ff"
            >
              <div style="font-size: 24px"><strong>16</strong></div>
              <div class="text-caption"><strong>Chương trình</strong></div>
            </v-card>
          </v-col>
          <v-col class="pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #ffb4c2"
            >
              <div style="font-size: 24px"><strong>7</strong></div>
              <div class="text-caption"><strong>Học phần</strong></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {}
</script>

<style></style>
